import React, { useState, useEffect } from "react";
import { RiArrowRightSLine } from "react-icons/ri";
import { getRequest, putRequest } from "../../helpers/api.helper";
import { StepPropsType } from "../../types";
import { useLanguage } from "../../context/LanguageContext";

const ensureArray = <T,>(value: T[] | null | undefined): T[] =>
  Array.isArray(value) ? value : [];

const Step3 = ({
  bureauId,
  setCurrentStep,
  currentStep,
  steps,
  profileId,
  setCompletedSteps,
}: StepPropsType) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");
  const [searchTerm3, setSearchTerm3] = useState("");
  const [modalData, setModalData] = useState<any>(null);
  const [modalData2, setModalData2] = useState<any>(null);
  const [modalData3, setModalData3] = useState<any>(null);

  const languageContext = useLanguage();

  const translate = (key: string) => {
    if (typeof languageContext?.t !== "function") {
      console.error("Step3 translation function unavailable", {
        languageContext,

        tType: typeof languageContext?.t,
      });

      return key;
    }

    return languageContext.t(key);
  };

  const [castes, setCastes] = useState([]);
  const [subCastes, setSubCastes] = useState([]);
  const [raasi, setRaasi] = useState([]);
  const [star, setStar] = useState([]);

  const [selectedOptions, setSelectedOptions] = useState<any>({
    Languages_Known: ["telugu"], // Default to Telugu
  });

  const [selectedOptions2, setSelectedOptions2] = useState<any>({
    religion: { value: "hindu", label: "Hindu" }, // Default for religion
    Mother_Tongue: { value: "telugu", label: "Telugu" }, // Default for mother tongue
    caste: null, // Default value for caste (to be fetched from API)
    subcaste: null, // Default value for sub-caste (to be fetched from API)
  });

  const [selectedOptions3, setSelectedOptions3] = useState<any>({
    raasi: null, // Default value for raasi (to be fetched from API)
    star: null, // Default value for star (to be fetched from API)
    dosham: null, // Dosham field with Yes/No options
  });

  const dropdownOptions: any = {
    Languages_Known: [
      { value: "bengali", label: "Bengali" },
      { value: "english", label: "English" },
      { value: "hindi", label: "Hindi" },
      { value: "kannada", label: "Kannada" },
      { value: "marathi", label: "Marathi" },
      { value: "tamil", label: "Tamil" },
      { value: "telugu", label: "Telugu" },
    ],
  };

  const dropdownOptions2: any = {
    religion: [
      { value: "buddhist", label: "Buddhist" },
      { value: "christian", label: "Christian" },
      { value: "hindu", label: "Hindu" },
      { value: "muslim", label: "Muslim" },
      { value: "sikh", label: "Sikh" },
    ],
    Mother_Tongue: [
      { value: "bengali", label: "Bengali" },
      { value: "english", label: "English" },
      { value: "hindi", label: "Hindi" },
      { value: "kannada", label: "Kannada" },
      { value: "marathi", label: "Marathi" },
      { value: "tamil", label: "Tamil" },
      { value: "telugu", label: "Telugu" },
    ],
    caste: [
      ...castes.map((caste: any) => ({
        value: caste.caste,
        label: caste.caste,
      })),
    ],
    subcaste: [
      ...subCastes.map((subcaste: any) => ({
        value: subcaste.sub_caste,
        label: subcaste.sub_caste,
      })),
    ],
  };

  const dropdownOptions3: any = {
    raasi: [
      ...raasi.map((raasi: any) => ({
        value: raasi.raasi,
        label: `${raasi.raasi} (${raasi.raasi_telugu})`,
      })),
    ],
    star: [
      ...star.map((star: any) => ({ value: star.star, label: star.star })),
    ],
    dosham: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  };

  const handleSelect2 = (selectedOption2: any) => {
    setSelectedOptions2({
      ...selectedOptions2,
      [modalData2.key]: selectedOption2,
    });
    closeModal2();
  };

  const handleSelect3 = (selectedOption3: any) => {
    setSelectedOptions3({
      ...selectedOptions3,
      [modalData3.key]: selectedOption3,
    });
    closeModal3();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRequest("/common/all");
        if (response.success) {
          setStar(ensureArray(response.data?.star));
          setCastes(ensureArray(response.data?.caste));
          setSubCastes(ensureArray(response.data?.subCaste));
          setRaasi(ensureArray(response.data?.raasi));
        }
      } catch (error) {
        console.error("Error fetching common profile data:", error);
      }
    };
    fetchData();
  }, []);
  const openModal = (key: any) =>
    setModalData({ key, options: dropdownOptions[key] });
  const closeModal = () => setModalData(null);

  const openModal2 = (key: any) =>
    setModalData2({ key, options: dropdownOptions2[key] });
  const closeModal2 = () => setModalData2(null);

  const openModal3 = (key: any) =>
    setModalData3({ key, options: dropdownOptions3[key] });
  const closeModal3 = () => setModalData3(null);

  useEffect(() => {
    if (modalData) {
      setSearchTerm(""); // Reset search term when opening a new modal
    }
  }, [modalData]);

  useEffect(() => {
    if (modalData2) {
      setSearchTerm2(""); // Reset search term when opening a new modal
    }
  }, [modalData2]);

  useEffect(() => {
    if (modalData3) {
      setSearchTerm3(""); // Reset search term when opening a new modal
    }
  }, [modalData3]);

  const handleCheckboxChange = (event: any, option: any) => {
    const { checked } = event.target;
    const updatedSelectedOptions = checked
      ? [...selectedOptions.Languages_Known, option.value]
      : selectedOptions.Languages_Known.filter(
          (lang: any) => lang !== option.value,
        );

    setSelectedOptions({
      ...selectedOptions,
      Languages_Known: updatedSelectedOptions,
    });
  };

  const handleSelectAllChange = (event: any) => {
    const { checked } = event.target;
    if (checked) {
      // Select all options
      setSelectedOptions((prevSelectedOptions: any) => ({
        ...prevSelectedOptions,
        Languages_Known: dropdownOptions.Languages_Known.map(
          (option: any) => option.value,
        ),
      }));
    } else {
      // Deselect all options
      setSelectedOptions((prevSelectedOptions: any) => ({
        ...prevSelectedOptions,
        Languages_Known: [],
      }));
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the page to the top
  }, []);

  useEffect(() => {
    if (!Array.isArray(selectedOptions.Languages_Known)) {
      setSelectedOptions((prev: any) => ({
        ...prev,
        Languages_Known: [],
      }));
    }
  }, [selectedOptions.Languages_Known, modalData]);

  const [formData, setFormData] = useState({
    gotram: "",
    unclesGotram: "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const capitalize = (text: string) =>
    text.charAt(0).toUpperCase() + text.slice(1);

  useEffect(() => {
    if (!profileId) return;
    if (!castes.length || !raasi.length) return;

    const fetchStep3Data = async () => {
      try {
        const res = await getRequest(`/bureau/profile/${profileId.martialId}`);
        if (!res?.data) return;

        const data = res.data;
        const savedLanguages = ensureArray<string>(data.languagesKnown);

        // Languages Known
        setSelectedOptions({
          Languages_Known: savedLanguages,
        });

        // Religion / Mother Tongue / Caste / Subcaste
        setSelectedOptions2({
          religion: data.religion
            ? { value: data.religion, label: capitalize(data.religion) }
            : selectedOptions2.religion,

          Mother_Tongue: data.motherTongue
            ? { value: data.motherTongue, label: capitalize(data.motherTongue) }
            : selectedOptions2.Mother_Tongue,

          caste: data.caste ? { value: data.caste, label: data.caste } : null,

          subcaste: data.subcaste
            ? { value: data.subcaste, label: data.subcaste }
            : null,
        });

        // Raasi / Star / Dosham
        setSelectedOptions3({
          raasi: data.raasi
            ? {
                value: data.raasi,
                label:
                  //@ts-ignore
                  raasi.find((r: any) => r.raasi === data.raasi)?.raasi ||
                  data.raasi,
              }
            : null,

          star: data.star ? { value: data.star, label: data.star } : null,

          dosham: data.dosham
            ? {
                value: data.dosham,
                label: capitalize(data.dosham),
              }
            : null,
        });

        // Gothram fields
        setFormData({
          gotram: data.gotram || "",
          unclesGotram: data.unclesGotram || "",
        });
      } catch (err) {
        console.error("Failed to load Step3 data", err);
      }
    };
    if (bureauId) fetchStep3Data();
  }, [profileId, castes.length, raasi.length]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    // Validate mandatory fields
    if (!selectedOptions2.caste?.value) {
      alert("Please select a caste");
      return;
    }
    if (!selectedOptions2.subcaste?.value) {
      alert("Please select a subcaste");
      return;
    }

    // Create formattedOptions, allowing empty values
    const formattedOptions = {
      religion: selectedOptions2.religion?.value || "",
      motherTongue: selectedOptions2.Mother_Tongue?.value || "",
      caste: selectedOptions2.caste?.value || "",
      subcaste: selectedOptions2.subcaste?.value || "",
      raasi: selectedOptions3.raasi?.value || "",
      star: selectedOptions3.star?.value || "",
      dosham: selectedOptions3.dosham?.value || "",
    };

    const dataToSend = {
      ...formattedOptions,
      languagesKnown: selectedOptions.Languages_Known || "",
      step1: 1,
      step2: 1,
      step3: 1,
      gotram: formData.gotram,
      unclesGotram: formData.unclesGotram,
    };

    try {
      const response = await putRequest(
        `/bureau/profile/${profileId?.userId}`,
        dataToSend,
      );
      if (response.success) {
        setCompletedSteps?.((prev) =>
          prev.includes(currentStep) ? prev : [...prev, currentStep],
        );
        if (currentStep < steps.length) {
          setCurrentStep(currentStep + 1);
        }
      } else {
        alert("Failed to update details.");
      }
    } catch (error: any) {
      console.error("Error updating details:", error.message);
      alert("An error occurred while updating details.");
    }
  };

  return (
    <div className="w-full max-w-4xl bg-white shadow-lg rounded-lg">
      <div className="space-y-6 py-4 px-3">
        {/* Languages Known */}
        {Object.keys(dropdownOptions).map((key) => (
          <div key={key} className="mb-[-20px]">
            <label className="block text-red-500 font-medium mb-2 capitalize">
              {translate(key.replace(/_/g, " "))}
            </label>

            <div
              className="flex flex-col w-full border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-lg transition-all rounded-lg"
              onClick={() => openModal(key)}
            >
              <div className="flex items-center justify-between">
                <span className="text-gray-500 text-md font-medium">
                  {selectedOptions[key]?.length
                    ? dropdownOptions[key]
                        .filter((opt: any) =>
                          selectedOptions[key].includes(opt.value),
                        )
                        .map((lang: any) => lang.label)
                        .join(", ")
                    : `Select ${key}`}
                </span>
                <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
              </div>
            </div>
          </div>
        ))}

        {/* Religion, Mother Tongue, Caste, Subcaste */}
        {Object.keys(dropdownOptions2).map((key) => (
          <React.Fragment key={key}>
            <div className="mb-[-20px]">
              <label className="block text-red-500 font-medium mb-2">
                {translate(key.replace(/_/g, " "))}{" "}
                {(key === "caste" || key === "subcaste") && (
                  <span className="text-red-600">*</span>
                )}
              </label>
            </div>

            <div
              className="flex flex-col w-full border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-lg transition-all rounded-lg"
              onClick={() => openModal2(key)}
            >
              <div className="flex items-center justify-between">
                <span className="text-gray-500 text-md font-medium">
                  {selectedOptions2[key]?.label || `Select ${key}`}
                </span>
                <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
              </div>
            </div>

            {/* Show Gothram fields right after subcaste */}
            {key === "subcaste" &&
              selectedOptions2.caste &&
              selectedOptions2.subcaste && (
                <div className="mt-6 space-y-4">
                  <div>
                    <label className="block text-red-500 font-medium mb-2">
                      {translate("Gothram Name")}
                    </label>
                    <input
                      type="text"
                      name="gotram"
                      value={formData.gotram}
                      onChange={(e) => {
                        const value = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          "",
                        );
                        handleChange({ target: { name: "gotram", value } });
                      }}
                      placeholder="Enter your Gothram name"
                      className="w-full p-4 border border-[#c4d4e2] rounded-md focus:outline-none focus:ring-2 focus:ring-[#c4d4e2] bg-white"
                    />
                  </div>
                  <div>
                    <label className="block text-red-500 font-medium mb-2">
                      {translate("Uncle's Gothram Name")}
                    </label>
                    <input
                      type="text"
                      name="unclesGotram"
                      value={formData.unclesGotram}
                      onChange={(e) => {
                        const value = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          "",
                        );
                        handleChange({
                          target: { name: "unclesGotram", value },
                        });
                      }}
                      placeholder="Enter your Uncle's Gothram name"
                      className="w-full p-4 border border-[#c4d4e2] rounded-md focus:outline-none focus:ring-2 focus:ring-[#c4d4e2] bg-white"
                    />
                  </div>
                </div>
              )}
          </React.Fragment>
        ))}

        {/* Raasi, Star, Dosham */}
        {Object.keys(dropdownOptions3).map((key) => (
          <React.Fragment key={key}>
            <div className="mb-[-20px]">
              <label className="block text-red-500 font-medium mb-2 capitalize">
                {translate(key.replace(/_/g, " "))}
              </label>
            </div>

            <div
              className="flex flex-col w-full border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-lg transition-all rounded-lg"
              onClick={() => openModal3(key)}
            >
              <div className="flex items-center justify-between">
                <span className="text-gray-500 text-md font-medium">
                  {selectedOptions3[key]?.label || `Select ${key}`}
                </span>
                <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>

      {/* Modal for Selecting Languages */}
      {modalData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {translate("Select")} {modalData.key}
            </h2>

            {/* "Select All" Checkbox */}
            <div className="flex items-center space-x-2 mb-4">
              <input
                id="selectAllCheckbox"
                type="checkbox"
                checked={
                  ensureArray(selectedOptions.Languages_Known).length ===
                  dropdownOptions.Languages_Known.length
                }
                onChange={handleSelectAllChange}
                className="form-checkbox h-4 w-4 text-red-600"
              />
              <label className="block text-gray-700">
                {translate("Select All")}
              </label>
            </div>

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData.key}`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData.options
                .filter((option: any) =>
                  option.label.toLowerCase().includes(searchTerm.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <>
                    <div key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={ensureArray(
                          selectedOptions.Languages_Known,
                        ).includes(option.value)}
                        onChange={(e) => handleCheckboxChange(e, option)}
                        className="form-checkbox h-4 w-4 text-red-600"
                      />
                      <label className="block text-gray-700 py-2">
                        {option.label}
                      </label>
                    </div>
                  </>
                ))}
            </div>
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal}
            >
              {translate("Continue")}
            </button>
          </div>
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex flex-col-reverse sm:flex-row gap-3 pt-6">
        {/* <button
          onClick={() => {
            setCurrentStep(Math.max(1, currentStep - 1));
          }}
          className="flex-1 px-6 py-3.5 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
        >
          Previous
        </button> */}
        <button
          onClick={handleSubmit}
          className="flex-1 px-6 py-3.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-semibold hover:from-pink-600 hover:to-purple-700 transition-all shadow-lg"
        >
          {currentStep === steps.length
            ? translate("Submit")
            : translate("Next Step")}
        </button>
      </div>

      {/* Modal for Selecting Options (dropdownOptions2) */}
      {modalData2 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {translate("Select")} {modalData2.key}
            </h2>

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData2.key}`}
              value={searchTerm2}
              onChange={(e) => setSearchTerm2(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData2.options
                .filter((option: any) =>
                  option.label
                    .toLowerCase()
                    .includes(searchTerm2.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <React.Fragment key={index}>
                    <div>
                      <button
                        className="block w-full text-left px-4 py-3 hover:bg-gray-100 transition"
                        onClick={() => handleSelect2(option)}
                      >
                        {option.label}
                      </button>
                      <hr className="border-gray-200 mt-3 mb-3" />
                    </div>
                  </React.Fragment>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal2}
            >
              {translate("Continue")}
            </button>
          </div>
        </div>
      )}

      {/* Modal for Selecting Options (dropdownOptions3) */}
      {modalData3 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {translate("Select")} {modalData3.key}
            </h2>

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData3.key}`}
              value={searchTerm3}
              onChange={(e) => setSearchTerm3(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {dropdownOptions3[modalData3.key]
                .filter((option: any) =>
                  option.label
                    .toLowerCase()
                    .includes(searchTerm3.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <React.Fragment key={index}>
                    <div>
                      <button
                        className="block w-full text-left px-4 py-3 hover:bg-gray-100 transition"
                        onClick={() => handleSelect3(option)}
                      >
                        {option.label}
                      </button>
                      <hr className="border-gray-200 mt-3 mb-3" />
                    </div>
                  </React.Fragment>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal3}
            >
              {translate("Continue")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step3;
